import _ from 'lodash';
import React, { PureComponent } from 'react';
import TableGrid from '../../views/TableGrid';
import { BadWeight, Duplicate, SoundsLike, Header, HeaderSub, Code, Text, CodeInline } from './../../views/typography';

export default (bottle) => {
  bottle.factory('SpottingGroupDrilldownAddHelp', () => {
    class SpottingGroupDrilldownAddHelp extends PureComponent {
      render() {
        return (
          <section>
            <Header>
              Help for Adding New Spotting Groups
            </Header>
            <Text>
              A group is a collection of words or phrases you expect to come up in sound files you want transcribed.
            </Text>
            <HeaderSub>Keywords</HeaderSub>
            <Text>
              Each group has a
              {' '}
              <b>Name</b>
              {' '}
              that you use when you include it for targeting, and a set of
              {' '}
              <b>Keywords</b>
              .
              A keyword can be one or many words or phrases (
              <CodeInline>coupon</CodeInline>
              {' '}
              or
              {' '}
              <CodeInline>direct deposit</CodeInline>
              ).
              You can paste a list of keywords from a CSV file or text editor, one per line as in:
            </Text>
            <div>
              <Code>coupon</Code>
            </div>
            <div>
              <Code>direct deposit</Code>
            </div>
            <div>
              <Code>Wildebeest</Code>
            </div>
            <HeaderSub>Update or Replace</HeaderSub>
            <Text>
              There is two ways to add keywords. By default the new entries are <i>combined</i>
              with the old ones, replacing any duplicates with the newer entries.
              If you check the &quot;Replace Terms&quot; checkbox, all the old keywords will be replaced
              with the terms in this form.
            </Text>
            <HeaderSub>Problem Highlighting</HeaderSub>
            <Text>
              If you have duplicate keywords these will be highlighted as in
            </Text>
            <TableGrid style={({ width: '100%' })}>
              <thead>
                <tr>
                  <th style={({ minWidth: 80 })}>Keyword</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <Duplicate>coupon</Duplicate>
                </tr>
                <tr>
                  <Duplicate>coupon</Duplicate>
                </tr>
                <tr>
                  <td>direct deposit</td>
                </tr>
                <tr>
                  <td>Wildebeest</td>
                </tr>
                <tr>
                  <td>Blazinski</td>
                </tr>
              </tbody>
            </TableGrid>
            <Header>Correction</Header>
            <Text>
              If for any reason you add bad data or want to update it, you can re-upload new keywords
              and they will replace the previous entry.
            </Text>
          </section>
        );
      }
    }

    return SpottingGroupDrilldownAddHelp;
  });
};
